<div class="content-alert">
  <img src="./assets/images/payment_require.svg" alt="Requer pagamento da empresa do usuario logado.">
  <div class="section">
    <h1>Aguardando Pagamento</h1>
    <p>Sr.(a), Desculpe pelo incomodo, a empresa que você está vinculado está com o pagamento em atraso,
      devido o ocorrido, algumas funcionalidades do sistema podem está bloqueadas.</p>
    <p>Entre em contato com o Suporte.</p>
  </div>
</div>

